<template>
  <div class="table">
    <table class="table table-striped table-hover">
      <thead>
      <tr>
        <th class="content">商品</th>
         <th class="brand">品牌</th>
        <th class="num">数量</th>
        <th class="price">单价(元)</th>
        <th class="money">金额(元)</th>
        <th class="order-state">订单状态</th>
        <th class="press-state">发货单号</th>
        <th class="operation">操作</th>
      </tr>
      </thead>
      <tbody style="width:100%; text-align:center; font-size:16px; height: 300px; line-height: 250px"
             v-if="list.length <= 0">暂无订单历史 <span style="
                  color: #ffbb00;
                  cursor: pointer;
                  text-decoration: underline;
                " @click="()=>{ this.$router.push('/productCenter')}">去逛逛</span></tbody>
      <tbody v-else>
      <template v-for="(item,index) in list">
        <tr class="tbody-null"></tr>
        <tr class="tbody-head" :key="index" style="display:flex;align-items:center;justify-content:space-between">
          <div style="display:flex;align-items:center">
              <span class="date">{{ getPartTime(item.create_time) }}</span>
            <span class="orderhao">订单号:{{ item.order_number }}</span>
            <span class="orderhao">收货人:{{ item.username }}</span>
            <div class="status-btn" v-show="item.pay_status == 0" style="background:#fff;color:#000;border:1px dashed #000;">待付款</div>
            <div class="status-btn" v-show="item.pay_status == 1" style="background:#f6ffed;color:#66cb34;border:1px solid #66cb34;">已付款</div>
            <div class="status-btn" v-show="item.pay_status == 2" style="background:#fff1f0;color:#ff7677;border:1px solid #ff7677;">已退款</div>
            <!-- <div class="status-btn" style="background:#f6ffed;color:#66cb34;border:1px solid #66cb34;">{{ ["待付款", "已付款", "已退款"][item.pay_status] }}</div> -->
            <!-- <div class="status-btn" style="background:#e6f7ff;color:#1890ff;border:1px solid #1890ff;">{{ ["待审核", "已审核", "已发货", "已完成", "已取消"][item.status]}}</div> -->
            <div class="status-btn" v-show="item.status == 0" style="background:#f5f5f5;color:#000;border:1px solid #000;">待审核</div>
            <div class="status-btn" v-show="item.status == 1" style="background:#fffbe6;color:#fbc555;border:1px solid #fbc555;">已审核</div>
            <div class="status-btn" v-show="item.status == 2" style="background:#e6f7ff;color:#1890ff;border:1px solid #1890ff;">已发货</div>         
            <div class="status-btn" v-show="item.status == 3" style="background:#f6ffed;color:#66cb34;border:1px solid #66cb34;">已完成</div>
            <div class="status-btn" v-show="item.status == 4" style="background:#fff1f0;color:#ff7677;border:1px solid #ff7677;">已取消</div>
            <div class="status-btn" v-show="item.status == 5" style="background:#e6f7ff;color:#1890ff;border:1px solid #1890ff;">部分发货</div>  
          </div>
          <div style="display:flex;align-items:center;padding-right:10px">
          <div class="top-btn"  v-if="item.status == 0"  @click="cancelOrder(item.order_number)">取消</div>
          <div class="top-btn" v-if="item.pay_status == 0"  @click="goPayload(item.order_number)">去付款</div>
          <div class="top-btn" @click="moreOrder(item.goods)">再来一单</div>
          <div class="top-btn" @click="goxq(item.order_number)">查看详情</div>
          </div>
        </tr>
        <tr class="tbody-main" v-for="(i, v) in item.goods" :key="item[v]">
          <td class="content" style="margin-left: unset">
            <div class="right" @click="goxqs(i.goods_code)">
              <p class="text">{{ i.goods_name }}</p>
              <p class="number">{{ i.customer_sku }}</p>
              <p class="english">{{ i.english }}</p>
            </div>
          </td>
           <td class="brand">
            <span
              v-show="item.brand !== null"
              :style="`background:${i.background_color};color:#ffbb00;padding:1px 10px;border-radius:20px`"
              >{{ i.brand }}</span
            >
          </td>
          <td class="num">
            <span>{{ i.num }}</span>
          </td>
          <td class="price">{{ i.price }}</td>
          <td class="money">{{ i.final_price }}</td>
          <td class="order-state" :rowspan="item.goods.length">
            {{
              [ "未发货", "已发货", "已取消"][i.detail_status]
            }}
          </td>
           <td class="press-state" :rowspan="item.goods.length">
            {{
             i.express_number
            }}
          </td>
          <td class="operation" :rowspan="item.goods.length">
            <button v-if="i.detail_status == 0 && item.pay_status > 0 " class="remove" @click="cancelOneOrder(i.id)">
              商品取消
            </button>
            <button v-if="i.detail_status == 1" class="remove" @click="salesReturn(item.goods[0].order_id)">
              申请退货
            </button>
            <!-- <button v-if="item.status == 2" @click="gowl(item.order_number)">查看物流</button> -->
          </td>
        </tr>
      </template>
      </tbody>
    </table>

    <el-dialog title="退货申请" width="1100px" :visible.sync="dialogTableVisible">
      <el-form ref="salesReturnData" label-width="80px">
        <el-form-item label="退货原因">
          <el-select v-model="salesReturnOrder.reason" placeholder="请选择">
            <el-option
                v-for="(item) in salesReturnData.reasonList"
                :key="item.key"
                :label="item.val"
                :value="item.key">
            </el-option>
          </el-select>
          <span style="color: red;">（必选项）</span>
        </el-form-item>
        <el-form-item label=" 退货备注">
          <el-input v-model="salesReturnOrder.remark" placeholder="请输入备注内容"></el-input>
        </el-form-item>
      </el-form>
      <el-table :data="salesReturnData.goodsList">
        <el-table-column property="goods_name" label="商品名称"></el-table-column>
        <el-table-column property="goods_code" label="商品编码"></el-table-column>
        <el-table-column property="sku" label="SKU"></el-table-column>
        <el-table-column property="batch_code" label="批次号"></el-table-column>
        <el-table-column property="num" label="订单数量"></el-table-column>
        <el-table-column property="number" label="发货数量"></el-table-column>
        <el-table-column label="退货数量">
          <template slot="header" slot-scope="scope">
            退货数量
            <el-button type="warning" size="mini" round @click="allReturn(scope.store.states.data)"><span v-show="showButton">选择整单</span><span
                v-show="!showButton">取消整单</span></el-button>
          </template>
          <template slot-scope="scope">
            <el-input-number style="width: 120px" v-model="scope.row.quantity" :min="0" :max="scope.row.number"
            label="描述文字"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAftersale">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["list"],
  data() {
    return {
      detailList: [],
      salesReturnData: '',
      dialogTableVisible: false,
      showButton: true,
      salesReturnOrder: {
        list: []
      }
    };
  },
  methods: {
    getPartTime(val){
          var timearr = val.replace(" ", ":").replace(/:/g, "-").split("-");
          var timestr = Number(timearr[0])+ "-"+ Number(timearr[1])+ "-" + timearr[2];
          return timestr;
     },
    moreOrder(products){
        let that = this
        new Promise(function (resolve, reject) { 
          products.forEach((item)=>{
              that.$api.shopCar.addcar({
                sku_id: item.sku_id,
                num: item.num
              }).then(res => {})
          })
        }) 
        that.getNewList(products)
     },
     getNewList(products){
      let newList = []
       products.forEach((item)=>{
            newList.push(item.sku_id)
       })
        sessionStorage.setItem("carList",newList);
        this.$router.push({
            name: "myorder"
        })
     },
    allReturn(dataList) {
      this.showButton = !this.showButton
      for (const Key in dataList) {
        if (!this.showButton) {
          dataList[Key].quantity = dataList[Key].number
        } else {
          dataList[Key].quantity = 0
        }
      }
    },
    goPayload(order_number) {
      this.$router.push({
        path: "/shopingCart/payload",
        query: {
          order_number: order_number,
        },
      });
    },
    goxq(order_number) {
      let routeUrl = this.$router.resolve({
        path: "/personalCenter/orderCenter/detail",
        query: {
          order_number: order_number
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    goxqs(id) {
      this.$router.push({
        path: `/homepage/detail`,
        query: {
          id: id,
        },
      });
    },
    gowl(order_number) {
      let routeUrl = this.$router.resolve({
        path: "/personalCenter/orderCenter/detail",
        query: {
          order_number: order_number,
          flag: true
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    cancelOneOrder(id){
        const h = this.$createElement;
        this.$prompt('您取消订单的原因：', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          message:  h('div', null, [
            h('p', { style: 'color: red'}, '商品取消后退款将返到账户余额'),
            h('p', { style: 'color: black' }, '您取消订单的原因：')
          ])
        }).then(({value}) => {
          this.$api.order.cancelOne({
            detail_id: id,
            remark: value
          }).then(res => {
            if(res.status == 1){
              location.reload()
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
    },
    cancelOrder(order_number) {
      this.$prompt('您取消订单的原因：', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({value}) => {
        this.$api.order.cancelOrder({
          order_number: order_number,
          remark: value
        }).then(res => {
           if(res.status == 1){
              location.reload()
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },

    salesReturn(order_id) {
      this.$api.order.salesReturn({
        order_id: order_id,
      }).then(res => {
        this.salesReturnData = res.data;
        this.dialogTableVisible = true
      })
    },
    addAftersale() {
      for (let item of this.salesReturnData.goodsList) {
        this.salesReturnOrder.order_id = item.order_id;
        if (item.quantity > 0 && item.quantity <= item.number) {
          this.salesReturnOrder.list.push({
            "detail_id": item.id,
            "batch_code": item.batch_code,
            "quantity": item.quantity
          })
        }
      }
      this.$api.order.addAftersale(
          this.salesReturnOrder
      ).then(res => {
        if (res.status === 0) {
          if (res.msg === '缺少售后参数') {
            this.$alert('请填写退货数量', '提示', {
              type: 'warning'
            })
          } else {
            this.$alert(res.msg, '提示', {
              type: 'warning'
            })
          }
        } else if (res.status === 1) {
          this.$message({
            message: '退货申请成功！',
            type: 'success'
          })
          this.dialogTableVisible = false
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
table {
  border-collapse: collapse;
}
.status-btn{
  height:22px;width:50px;line-height:20px;text-align:center;font-size:12px;margin-left:15px
}
.top-btn{
  background:#1890ff;
  color:#fff;
  border-radius: 3px;
  height:26px;
  min-width:50px;
  line-height:26px;
  text-align:center;
  padding:0px 10px;
  font-size:12px;
  margin-left:10px;
  cursor: pointer;
}

thead {
  width: 876px;
  height: 58px;
  background: #f5f5f5;

  tr {
    display: flex;
    line-height: 58px;
    font-size: 15px;
    color: #000
  }
}

tbody {
  .tbody-null {
    height: 10px;
  }

  .tbody-head {
    // height: 38px;
    background: #f5f5f5;
    border-top: none;
    line-height: 38px;
    color:#000;
    font-size: 12px;
    .date {
      padding-left:15px;
    }

    .orderhao {
      padding-left: 15px;
    }
  }

  .tbody-main {
    width: 876px;
    min-height: 80px;
    border: 1px solid #dddddd;
    border-top: none;
    background: #fff;
    display: flex;
    align-items: center;
    .colspan {
      display: flex;
    }
  }
}

thead tr,
.tbody-main {
  text-align: center;
  .content {
    width: 280px;
    padding-left: 20px;
    text-overflow: ellipsis;
    display: inline-block;
    text-align: left;
    cursor: pointer;

    .number {
      color: #A52A2A;
    }
  }
  .brand{
    width: 90px;
  }
  .num {
    width: 62px;
  }

  .price {
    width: 73px;
  }

  .money {
    width: 72px;
  }

  .pay-state {
    width: 72px;
    cursor: pointer;
  }

  .pay-state {
    width: 72px;
  }

  .order-state {
    width: 72px;
  }
  .press-state{
    width: 130px;
  }
  .operation {
    width: 100px;
    display: flex;
    flex-direction: column;
    button {
      background:#1890ff;
      color:#fff;
      border-radius: 3px;
      height:26px;
      width:80px;
      line-height:26px;
      text-align:center;
      padding:0px 10px;
      font-size:12px;
      margin-left:10px;
      cursor: pointer;
      border:0;
    }
  }
}

// el-dialog高度自适应，内容超出时中间出现滚动条
.common-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

  .el-dialog {
    margin: 0 auto !important;
    position: relative;

    .el-dialog__header {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      width: 100%;
      height: 60px;
      z-index: 1;
    }

    .el-dialog__body {
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      max-height: 90vh; //最大高度为视口高度的90%
      padding-top: 80px;
      padding-bottom: 100px;
      z-index: 1;
    }

    .el-dialog__footer {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 80px;
      z-index: 1;
    }
  }
}

// el-dialog高度自适应，内容超出时中间出现滚动条
.common-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

  .el-dialog {
    margin: 0 auto !important;
    position: relative;

    .el-dialog__header {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      width: 100%;
      height: 60px;
      z-index: 1;
    }

    .el-dialog__body {
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      max-height: 90vh; //最大高度为视口高度的90%
      padding-top: 80px;
      padding-bottom: 100px;
      z-index: 1;
    }

    .el-dialog__footer {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 80px;
      z-index: 1;
    }
  }
}


</style>
